import { guides } from '@/mocks/guides';
import { guideDetails } from '@/mocks/guideDetails';
import { guideDetails2 } from '@/mocks/guideDetails2';

export type Guide = (typeof guides)[number];

export type GuideDetail = {
  slug: string;
  intro: string;
  riskNote: string;
  sections: { heading: string; paragraphs: string[] }[];
  signals: string[];
  checklist: string[];
};

const detailMap: Record<string, GuideDetail> = {
  ...guideDetails,
  ...guideDetails2,
};

export const allGuides = guides;

export function getGuideBySlug(slug: string): Guide | undefined {
  return guides.find((item) => item.slug === slug);
}

export function getGuideDetail(slug: string): GuideDetail | undefined {
  return detailMap[slug];
}

export function getRelatedGuides(slug: string, limit = 3): Guide[] {
  const current = getGuideBySlug(slug);
  if (!current) return guides.slice(0, limit);
  const sameCategory = guides.filter((item) => item.slug !== slug && item.category === current.category);
  const others = guides.filter((item) => item.slug !== slug && item.category !== current.category);
  return [...sameCategory, ...others].slice(0, limit);
}

export const riskMeta: Record<string, { label: string; className: string; dot: string }> = {
  high: {
    label: '高风险',
    className: 'bg-accent-100 text-accent-800 border-accent-200',
    dot: 'bg-accent-500',
  },
  mid: {
    label: '中风险',
    className: 'bg-primary-100 text-primary-800 border-primary-200',
    dot: 'bg-primary-500',
  },
  low: {
    label: '低风险',
    className: 'bg-secondary-100 text-secondary-800 border-secondary-200',
    dot: 'bg-secondary-500',
  },
};